var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('p',[_vm._v("Today is "+_vm._s(_vm.weekday))]),_c('button',{on:{"click":_vm.findNextAvailableMonday}},[_vm._v("Next Monday")])])}
var staticRenderFns = []

export { render, staticRenderFns }